"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrightcoveVRVideo1Schema = void 0;
exports.BrightcoveVRVideo1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/redbull_com-vr-video/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "BrightcoveVRVideo1",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:redbull_com-vr-video:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "allowEmbedding": {
                    "type": "boolean",
                    "default": true
                },
                "refId": {
                    "type": "string"
                }
            },
            "required": [
                "allowEmbedding",
                "refId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9yZWRidWxsX2NvbS12ci12aWRlby8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLHdCQUF3QixHQUFHO0lBQ3RDLEtBQUssRUFBRSx5RkFBeUY7SUFDaEcsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsb0JBQW9CO0lBQzdCLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTixpREFBaUQ7YUFDbEQ7U0FDRjtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixnQkFBZ0IsRUFBRTtvQkFDaEIsTUFBTSxFQUFFLFNBQVM7b0JBQ2pCLFNBQVMsRUFBRSxJQUFJO2lCQUNoQjtnQkFDRCxPQUFPLEVBQUU7b0JBQ1AsTUFBTSxFQUFFLFFBQVE7aUJBQ2pCO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsZ0JBQWdCO2dCQUNoQixPQUFPO2FBQ1I7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==